
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerEditor("Matrix.Rebalancer.TradeMacroStepGrid", [Serenity.IReadOnly])
    @Serenity.Decorators.element("<div/>")
    export class TradeMacroStepGrid extends SiteEntityGrid<TradeMacroStepRow, any>
        implements Serenity.IReadOnly {
        protected getColumnsKey() { return 'Rebalancer.TradeMacroStep'; }
        protected getDialogType() { return TradeMacroStepDialog; }
        protected getIdProperty() { return TradeMacroStepRow.idProperty; }
        protected getLocalTextPrefix() { return TradeMacroStepRow.localTextPrefix; }
        protected getService() { return TradeMacroStepService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        private _readOnly: boolean;

        get_readOnly(): boolean {
            return !!this._readOnly;
        }

        set_readOnly(value: boolean): void {
            if (!!this._readOnly !== !!value) {
                this._readOnly = !!value;
                this.updateInterface();
            }
        }

        protected updateInterface() {
            this.toolbar.findButton('add-button').toggle(!this._readOnly && !!this._macroCode);
        }

        private _macroCode: string;

        public set macroCode(value: string) {
            if (this._macroCode !== value) {
                this._macroCode = value;
                this.setEquality(TradeMacroStepRow.Fields.MacroCode, value);
                this.refresh();
            }
        }

        protected addButtonClick() {
            this.editItem(<TradeMacroStepRow>{
                MacroCode: this._macroCode
            });
        }

        protected getInitialTitle() {
            return null;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this._macroCode;
        }
    }
}